export const version = "ethers/5.6.4";
//# sourceMappingURL=_version.js.map